export default __webpack_public_path__ + "static/media/fMaltoBuza9.c3252a0f.png";